import script from "./ContactInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactInformation.vue?vue&type=script&setup=true&lang=js"

import "./ContactInformation.vue?vue&type=style&index=0&id=a86f3474&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a86f3474"]])

export default __exports__